export class DirectorResponseDeleteCommand {
    constructor(
        public readonly VarianceId: string,
        public readonly DirectorResponseId: string,
    ) {}
}
